goog.provide('el8.ext.onboarding.challengeQs');


el8.ext.onboarding.challengeQs = [
    'What was the make of your first car?',
    'What school did you attend in the 6th Grade?',
    'What street did you live on in the 3rd Grade?',
    'What was your high school mascot?',
    'What is the name of your first pet?',
    'In what city or town was your first job?',
    'In what city or town did your mother and father meet?',
    'What is your oldest cousin\'s first and last name?',
    'What is your oldest sibling\'s first name?',
    'What is your youngest sibling\'s birthday month and year (MM/YYYY)?',
    'What is the first name of the boy or girl that you first kissed?',
    'What is the name of the place your wedding reception was held?',
    'What is the middle name of your oldest child?'
];

